import "choices.js/public/assets/styles/choices.css";

import Choices from "choices.js";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select", "projectId", "label"];

  connect() {
    this.choices = new Choices(this.selectTarget, {
      searchEnabled: true,
      itemSelectText: "",
    });
    this.onChange = this.onChange.bind(this);
    this.selectTarget.addEventListener("change", this.onChange);
    this.onChange();
  }

  disconnect() {
    this.selectTarget.removeEventListener("change", this.onChange);
    this.choices.destroy();
  }

  onChange() {
    const option = this.selectTarget.selectedOptions[0];
    if (this.hasProjectIdTarget) this.projectIdTarget.value = option?.dataset.projectId || "";
    if (this.hasLabelTarget) this.labelTarget.value = option?.dataset.label || "";
  }
}
